import styled, { css } from 'styled-components'

export const StyledDocumentCardIcons = styled.div`
  position: relative;
  top: 2px;

  height: 0px; /* This ensures the icons do not add extra height to the line */

  display: inline-flex;
  align-items: center;
`

export const StyledIcon = styled.svg.attrs({
  role: 'img',
})(
  ({ theme: { colors } }) => css`
    margin-left: 4px;
    width: 16px;
    height: 16px;
    color: ${colors.foreground.secondary[4]};
  `
)
